import React, { useState, useEffect } from 'react';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Icon from '../../components/atoms/Icon';
import Button from '../../components/atoms/Button';
import ItemListed from '../../components/molecules/ItemListed';
import StaticContent from '../../components/templates/StaticContent';
import AccountLayer from '../../components/organisms/AccountLayer';
import PageDefault from '../../components/templates/PageDefault';
import styles from '../../styles/pages/Promote.module.scss';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setVenue, getVenueState } from '../../features/venue/venueSlice';
import { useAuth } from '../../context/AuthUserContext';
import { useApp } from '../../context/AppContext';
import { localeFiles, resultsInfo } from '../../data/constants';
import { display } from '../../data/display';
import { demo } from '../../data/demo';
import { pages } from '../../data/pages';
import { geolocate } from '../../lib/geoapify';
import {
  clearObj,
  serializePrismaObject,
  toLocationStr,
} from '../../lib/utils';
import { prisma } from '../../db';

interface PageProps {
  locale: string;
  venue?: any;
  service?: any;
  ipLocation?: any;
}

const Page = (props: PageProps) => {
  const router = useRouter();
  const { t } = useTranslation(['common', 'pages']);
  const { identity } = useAuth();
  const { devMode } = useApp();
  const dispatch = useAppDispatch();
  const venueState = useAppSelector(getVenueState) as any; //as Venue;
  const [layer, setLayer] = useState() as any;
  const [ipLocation, setIpLocation] = useState() as any;
  const { locale, pathname } = router;
  const { venue, service } = props;
  const slug = pathname.replace('/', '');

  const onClaim = (type: string) => {
    if (identity) {
      router.push(`/${slug}/create/${type}`);
    } else {
      setLayer({
        closeBtn: false,
        bg: false,
        children: (
          <AccountLayer
            currView={'signup'}
            // redirect={`/promote-your-business/create/${type}`}
            toggle={() => setLayer({ ...layer, children: null })}
          />
        ),
      });
    }
  };

  // const packageLayer = (type: string) => setLayer({
  //   closeBtn: true,
  //   full: true,
  //   children: <PackagesLayer type={type}/>
  // });

  const sections = (!!locale && pages[locale][slug]) || [
    {
      h1: t(`pages:${slug}:title`),
      children: [t(`pages:${slug}:description`)],
    },
  ];

  // const toast = !!id
  //   ? {
  //       children: (
  //         <>
  //           <small>
  //             <b>{name}</b>
  //             <br />
  //             {toLocationStr(location.address || {}, true)}
  //           </small>
  //           <div>
  //             {/* {<small>{t(`pages:about:navi`)}</small>} */}
  //             <Button
  //               medium
  //               label={t(`pages:${slug}:cta-claim-venue`)}
  //               onClick={() => onClaim("venue")}
  //             />
  //           </div>
  //         </>
  //       ),
  //     }
  //   : undefined;

  const getDemoData = (scope: string) => {
    // ?venue_id=ckz2ydtqp00004k8zmqgxsitq2

    const data = {
      ...demo.venue[scope],
      location: ipLocation,
      ...venueState,
      // images: venueState.images.length
      plan: scope.toUpperCase(),
    };

    const defaultVenueData = {
      ...display.venue[scope].intro,
      ...display.venue[scope].properties.general,
    };

    const specs = resultsInfo.venues.map((key: any) => {
      const val = data[key] || defaultVenueData[key].value;
      const unit = defaultVenueData[key].unit;
      const value = typeof val === 'boolean' ? t(`venue:${val}`) : val;
      const label = t(`venue:${key}`);
      return { id: key, value, label, unit };
    });

    const demoObj = {
      // ...demo.venue[scope],
      ...clearObj(data),
      specs,
    };

    // console.log('getDemoData', demoObj);
    return demoObj;
  };

  useEffect(() => {
    // if (venueState.id !== venue.id) {
    if (!!venue && !!venue.id) {
      const venueObj = clearObj({
        ...venue,
        type: 'venue',
        rates: '0',
        rating: '0',
        status: null,
      });
      console.log('setVenue', venue, venueObj);
      dispatch(setVenue(venueObj));
    } else {
      const getLocation = async () => {
        const location = await geolocate();
        const { city, country, state } = location || {};
        setIpLocation({
          address: {
            city: city?.name || '',
            state: state?.name || '',
            country: country?.name || '',
          },
        });
      };
      getLocation();
    }
  }, [venue, dispatch]);

  return (
    <>
      <Head>
        <title>
          {t(`pages:${slug}:title`)} | {t('app-name')}
        </title>
        <meta name="description" content={t(`pages:${slug}:description`)} />
      </Head>

      <PageDefault
        className={styles.page_promote}
        toast={undefined}
        layer={layer}
      >
        {sections?.map((section: any, i: number) =>
          i < 2 ? (
            <StaticContent
              key={String(i)}
              h1={section.h1}
              h2={section.h2}
              imgs={section.imgs}
              p={section.children}
              full={section.full || (section.children || []).length === 1}
              hero={section.hero}
            />
          ) : (
            ''
          )
        )}

        <Row>
          <Col md={6} className={'offset-md-1'}>
            <br />
            <br />
          </Col>
          <>
            <Col xs={3} className="offset-1">
              <Button
                full
                large
                dark
                colored
                icon="venue"
                label={t(`pages:${slug}:cta-list-venue`)}
                onClick={() => onClaim('venue')}
              />
            </Col>
            <Col xs={3}>
              <Button
                full
                large
                dark
                colored
                icon="service"
                label={t(`pages:${slug}:cta-list-service`)}
                onClick={() => onClaim('service')}
              />
            </Col>
          </>
          <Col md={6} className={'offset-md-1'}>
            <br />
            <br />
          </Col>
        </Row>

        <StaticContent
          key={'staticcontentregion'}
          h1={sections[2].h1}
          h2={sections[2].h2}
          imgs={sections[2].imgs}
          p={sections[2].children}
          full={sections[2].hero || (sections[2].children || []).length === 1}
          hero={sections[2].hero}
        />

        <Row>
          <Col md={6} className={'offset-md-1'}>
            {/* <br/><br/>
          <small>Upgrade and stand out in the search results.</small>
          <br/><br/> */}
            <br />
            <br />
            <ItemListed disabled data={{ ...getDemoData('basic') }} />
            <br />
            <br />
          </Col>
        </Row>

        <Row className="justify-content-md-center">
          <Col>
            <br />
            <Icon name="arrow-big-down" />
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={6} className={'offset-md-1'}>
            <br />
            <br />
            <ItemListed disabled large data={getDemoData('platinum')} />
            <br />
            <ItemListed
              disabled
              className={styles.itemEmpty}
              data={{ type: 'venue', specs: [] }}
            />
            <ItemListed
              disabled
              className={styles.itemEmpty}
              data={{ type: 'venue', specs: [] }}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6} className={'offset-md-1'}>
            <br />
            <br />
          </Col>
          <>
            <Col xs={3} className="offset-1">
              <Button
                full
                large
                dark
                colored
                icon="service"
                label={t(`pages:${slug}:cta-service-package`)}
                href="/service-provider-package"
              />
            </Col>
            <Col xs={3}>
              <Button
                full
                large
                dark
                colored
                icon="venue"
                label={t(`pages:${slug}:cta-book-upgrade`)}
                href="/venue-packages"
              />
            </Col>
          </>
          <Col md={6} className={'offset-md-1'}>
            <br />
            <br />
          </Col>
        </Row>

        <StaticContent key={'staticcontentregion2'} imgs={sections[3].imgs} />
        {/* <Row>
        <Col md={4} lg={2}  className="offset-md-2 offset-lg-3 ">
          <br/><br/>
          <Button full large dark colored label="Claim your venue" icon="venue" onClick={() => setLayer("login")}/>
        </Col>
      </Row> */}
      </PageDefault>
    </>
  );
};

export default Page;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { locale, query } = context;
  const { venue_id, service_id } = query;
  //?venue_id=ckz2ydtqp00004k8zmqgxsitq

  const props = {
    ...(await serverSideTranslations(locale!, localeFiles)),
  };

  if (!venue_id && !service_id) {
    return {
      props: { ...props },
    };
  }

  if (!!venue_id) {
    try {
      const venue = await prisma.venue.findFirst({
        where: { id: venue_id as string },
        include: {
          sales_contacts: false,
          venue_spaces: false,
          management_contacts: false,
          contact_details: true,
          images: true,
          location: true,
          service_providers: false,
          reviews: false,
        },
      });

      return {
        props: {
          ...props,
          venue: serializePrismaObject(venue),
        },
      };
    } catch (e) {
      console.error(e);
    }
  } else if (!!service_id) {
    try {
      const service = await prisma.serviceProvider.findFirst({
        where: { id: service_id as string },
        include: {
          sales_contacts: false,
          management_contacts: false,
          contact_details: true,
          images: true,
          location: true,
          venues: false,
          reviews: false,
        },
      });

      return {
        props: {
          ...props,
          service: serializePrismaObject(service),
        },
      };
    } catch (e) {
      console.error(e);
    }
  }
}
